import { Box, Typography } from '@mui/material'

import MainContainer from '@ecm/ui/element/MainContainer'
import Metric from '@ecm/ui/element/Metric'

import oilIcon from '/public/images/icon/oil.svg'
import recycleIcon from '/public/images/icon/recycle.svg'
import treesIcon from '/public/images/icon/trees.svg'
import waterIcon from '/public/images/icon/water.svg'

const environmentalImpact = [
  {
    icon: recycleIcon,
    label: (
      <>
        <b>Pounds</b> recycled
      </>
    ),
    value: '186,377',
  },
  {
    icon: treesIcon,
    label: (
      <>
        <b>Trees</b> saved
      </>
    ),
    value: '1,586',
  },
  {
    icon: oilIcon,
    label: (
      <>
        <b>Gallons</b> of oil saved
      </>
    ),
    value: '35,411',
  },
  {
    icon: waterIcon,
    label: (
      <>
        <b>Gallons</b> of water saved
      </>
    ),
    value: '652,319',
  },
]

const EnvironmentalImpact = () => (
  <MainContainer
    sx={{
      py: '2em',
    }}
  >
    <Typography variant="h3" component="h2" maxWidth="500px">
      Our environmental impact in 2021
    </Typography>
    <Box
      display="grid"
      gap="0.5em"
      gridTemplateColumns={{ md: 'repeat(4, 1fr)', sm: 'repeat(2, 1fr)' }}
      pt={{ md: '4em', sm: '3em', xs: '2em' }}
    >
      {environmentalImpact.map(item => (
        <Metric key={item.value} {...item} />
      ))}
    </Box>
  </MainContainer>
)

export default EnvironmentalImpact
